import { render, staticRenderFns } from "./AktifChart.vue?vue&type=template&id=5b87d852&scoped=true"
import script from "./AktifChart.vue?vue&type=script&lang=js"
export * from "./AktifChart.vue?vue&type=script&lang=js"
import style0 from "./AktifChart.vue?vue&type=style&index=0&id=5b87d852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87d852",
  null
  
)

export default component.exports